import { Box, Button, Typography } from "@mui/material";
import { Warning, OpenInBrowser } from "@mui/icons-material";

interface ChatAbaUnicaOverlayProps {
    motivo: 'outra-aba-ativa' | 'assumida-por-outra';
    onAssumirControle: () => void;
}

export const ChatAbaUnicaOverlay = ({ motivo, onAssumirControle }: ChatAbaUnicaOverlayProps) => {
    const isNovaAba = motivo === 'outra-aba-ativa';

    return (
        <Box
            position="fixed"
            top={0}
            left={0}
            width="100vw"
            height="100vh"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            bgcolor="rgba(0, 0, 0, 0.88)"
            zIndex={99999}
            gap={3}
        >
            <Warning sx={{ fontSize: 64, color: '#f59e0b' }} />

            <Typography variant="h5" color="white" textAlign="center" maxWidth={480} fontWeight={600}>
                {isNovaAba
                    ? 'Chat aberto em outra aba'
                    : 'Esta aba foi desativada'}
            </Typography>

            <Typography variant="body1" color="rgba(255,255,255,0.7)" textAlign="center" maxWidth={440}>
                {isNovaAba
                    ? 'O chat já está aberto em outra aba. Para evitar conflitos com o socket, ele só pode ser usado em uma aba por vez.'
                    : 'O chat foi assumido por outra aba. Clique abaixo para usar o chat nesta aba e desativar a outra.'}
            </Typography>

            <Button
                variant="contained"
                size="large"
                onClick={onAssumirControle}
                startIcon={<OpenInBrowser />}
                sx={{ mt: 1 }}
            >
                Usar nesta aba
            </Button>
        </Box>
    );
};
